export default "__VITE_ASSET__BcmccqeL__ 600w";